





























































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapActions, mapGetters } from 'vuex';
import { storeModuleName } from '@/views/App/Profile/store';
import { CatalogItem } from 'src/requests/mainApi/models';
import { CatalogV1ItemMyListRequest } from 'src/requests/mainApi';
import SlideList from '@/components/modules/App/SlideList.vue';
import LongFlatCard from '@/components/modules/App/Profile/LongFlatCard.vue';
import NoFlatPlug from '@/components/modules/App/Profile/NoFlatPlug.vue';
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin';

type BuildingStateFilter = 'all' | 'unfinished' | 'hand-over';

interface Data {
  viewCurrentFlat: CatalogItem | null;
  countInChunk: number;
  building_state: BuildingStateFilter;
}

interface Methods {
  onSelectChunk: (value: CatalogItem[]) => void;
  setBuildingStateFilter: (e: Event) => void;
  getMyFlats: (payload: CatalogV1ItemMyListRequest) => Promise<CatalogItem[]>;
}

interface Computed {
  loadingFlats: boolean;
  myFlats: CatalogItem[];
}

interface Props {}

export default Vue.extend({
  name: 'MyFlats',
  components: {
    SlideList,
    LongFlatCard,
    NoFlatPlug,
  },
  data() {
    return {
      building_state: 'all',
      viewCurrentFlat: null,
      countInChunk: 1,
    };
  },
  mixins: [iconsMixin],
  computed: {
    ...mapGetters(storeModuleName, ['myFlats', 'loadingFlats']),
  },
  methods: {
    ...mapActions(storeModuleName, ['getMyFlats']),
    onSelectChunk(value: CatalogItem[]) {
      this.viewCurrentFlat = value[0];
    },

    setBuildingStateFilter(e: Event) {
      const filter = (e.target as HTMLButtonElement).value;
      this.building_state = filter as BuildingStateFilter;
      this.getMyFlats({ building_state: filter as BuildingStateFilter });
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
